module.exports = __webpack_public_path__ + "8cd4dfc7940c0cfdd716edc405bded88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/bg_4.jpg
// module id = 245
// module chunks = 1